import React, { useState } from "react"
import { useRequestCarrotCard } from "../request-carrot-card"
import { Form, FormCheckbox } from "@carrotfertility/carotene-core-x"
import { AirwallexUserAgreementTemplate, IssuingRegion } from "../agreement-helpers"
import { useAirwallexCardRequestSubmit } from "../../CardholderNameReview/use-name-on-card"
import { FormattedMessage } from "react-intl"
import { Link } from "@carrotfertility/carotene-core"
import { useStateMachine } from "#/components/context/stateMachine/StateMachineV2"
import { HttpErrors } from "#/utils/HttpErrors"

export function AirwallexCanadaUserAgreement() {
  const { send } = useStateMachine()
  const [isAddressError, setIsAddressError] = useState(false)
  const requestCardMutation = useRequestCarrotCard({
    onSuccess: () => send(""),
    onError: (error) => {
      if (error.name === HttpErrors.BAD_REQUEST && error.message.includes("postal_address")) {
        setIsAddressError(true)
      } else {
        setIsAddressError(false)
      }
    }
  })
  const submitCardRequest = useAirwallexCardRequestSubmit(requestCardMutation.mutateAsync)

  return (
    <Form
      onSubmit={submitCardRequest}
      defaultValues={{ airwallexUserAgreement: false, airwallexPaperlessNotificationsAgreement: false }}
    >
      <AirwallexUserAgreementTemplate
        data-testid={`issuing-region-${IssuingRegion.Canada}`}
        disableContinue={["airwallexUserAgreement", "airwallexPaperlessNotificationsAgreement"]}
        userAgreementChecks={[
          <FormCheckbox
            name={"airwallexUserAgreement"}
            key="user-agreement"
            label={
              <FormattedMessage
                values={{
                  cardHolderLink: (linkContent) => (
                    <Link
                      href="https://www.airwallex.com/ca/terms/cardholder-commercial"
                      target="_blank"
                      color="inherit"
                    >
                      {linkContent}
                    </Link>
                  ),
                  privacyPolicyLink: (linkContent) => (
                    <Link
                      href="https://www.airwallex.com/ca/terms/privacy-policy#scope-of-policy"
                      target="_blank"
                      color="inherit"
                    >
                      {linkContent}
                    </Link>
                  )
                }}
                defaultMessage="I consent to the <cardHolderLink>cardholder terms</cardHolderLink> and <privacyPolicyLink>privacy policy</privacyPolicyLink>."
              />
            }
            required
          />,
          <FormCheckbox
            key="paperless-notifications"
            name={"airwallexPaperlessNotificationsAgreement"}
            label={
              <FormattedMessage
                defaultMessage="I consent to paperless notifications and accept the <paperlessCommsLink>electronic communications consent agreement</paperlessCommsLink>."
                values={{
                  paperlessCommsLink: (linkContent) => (
                    <Link
                      href="https://www.airwallex.com/ca/terms/airwallex-electronic-communication-consent"
                      target="_blank"
                      color="inherit"
                    >
                      {linkContent}
                    </Link>
                  )
                }}
              />
            }
            required
          />
        ]}
        isError={requestCardMutation.isError}
        isAddressError={isAddressError}
      />
    </Form>
  )
}
